import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

class TermsAndCondition extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let body = document.body;
    body.className = 'terms-and-conditions';
  }

  render() {
    return (
      <Fragment>
        {' '}
        <div className="main-content yss-site--main__content Bullets">
          <div className="main-site__content">
            <div className="page__content">
              <div className="section--wrapper">
                <div className="section--width">
                  <div className="information_block block--para--lists">
                    <div className="block--title">
                      <h2>Coacherly General Terms and Conditions</h2>
                    </div>
                    <div className="block--text">
                      <p>
                        This Site is intended to provide users with general
                        information. We do not recommend or endorse any specific
                        coaches, nor do we endorse the guidance that any
                        particular coach offers. Reliance on any information
                        provided by coaches you engage through the Coacherly
                        platform is solely at your own discretion.
                      </p>
                      <div>
                        <p>
                          <strong>1. Introduction</strong>
                        </p>
                        <p>
                          Coacherly is an addiction coaching platform wholly
                          owned and operated by the Connecticut Community for
                          Addiction Recovery (“CCAR”), a not-for-profit entity
                          located in the U.S. State of Connecticut. Coacherly’s
                          sole purpose is to match independent addiction coaches
                          with individuals seeking coaching related to addiction
                          recovery and to facilitate coaching sessions.{' '}
                        </p>
                        <p>
                          These Standard Terms and Conditions (these “Terms” or
                          these “Standard Terms And Conditions”) contained on
                          this webpage and within the Coacherly platform
                          (together, “the Platform” or “Platform”), govern your
                          use of the Platform, including all pages associated
                          with the Platform. By using the Platform, you
                          expressly accept these terms and conditions.
                        </p>
                        <p>
                          These Terms apply only to the use of the Coacherly
                          platform, and do not apply to the use of other CCAR
                          properties. The Platform is not for use, and must not
                          be used, by any minors (defined as those who are not
                          at least 18 years of age).
                        </p>
                        <p>
                          <strong>2. Intellectual Property Rights</strong>
                        </p>
                        <p>
                          Other than content you own, which you may have opted
                          to share via the Platform, under these Terms, CCAR
                          and/or its licensors own all rights to the
                          intellectual property and material contained in the
                          Platform, and all such rights are reserved. You are
                          granted a limited license only, subject to the
                          restrictions provided in these Terms, for purposes of
                          viewing the material contained on the Platform.
                        </p>
                        <p>3. Restrictions</p>
                        <p>
                          Your use of the Platform means you expressly agree
                          that you will not:
                        </p>
                        <ul>
                          <li>
                            1. publish any Platform material in any media;
                          </li>
                          <li>
                            2. sell, sublicense and/or otherwise commercialize
                            any Platform material;
                          </li>
                          <li>
                            3. publicly perform and/or show any Platform
                            material;
                          </li>
                          <li>
                            4. use the Platform in any way that is, or may be,
                            damaging to the Platform;
                          </li>
                          <li>
                            5. use the Platform in any way that impacts user
                            access to the Platform;
                          </li>
                          <li>
                            6. use the Platform contrary to applicable laws and
                            regulations, or in a way that causes, or may cause,
                            harm to the Platform, or to any person or business
                            entity;
                          </li>
                          <li>
                            7. engage in any data mining, data harvesting, data
                            extracting or any other similar activity in relation
                            to the Platform, or while using the Platform; or
                          </li>
                          <li>
                            8. use the Platform to engage in any advertising or
                            marketing.
                          </li>
                        </ul>
                        <p>
                          Certain areas of the Platform are restricted from
                          access by you and CCAR may further restrict access by
                          you to any areas of the Platform, at any time, in its
                          sole and absolute discretion. Any user ID and password
                          you may have for the Platform are confidential and you
                          must maintain confidentiality of such information.
                        </p>
                        <p>
                          <strong>4. No warranties</strong>
                        </p>
                        <p>
                          The Platform is provided “as is,” with all faults, and
                          CCAR makes no express or implied representations or
                          warranties of any kind related to the Platform or the
                          materials contained on the Platform. Additionally,
                          guidance provided by coaches engaged through the
                          Platform is the guidance of that coach and is not
                          endorsed by CCAR itself.
                        </p>
                        <p>
                          <strong>5. Limitation of liability</strong>
                        </p>
                        <p>
                          In no event shall CCAR, nor any of its officers,
                          directors and employees, be liable to you for anything
                          arising out of or in any way connected with your use
                          of the Platform, whether such liability is under
                          contract, tort or otherwise, and CCAR, including its
                          officers, directors and employees shall not be liable
                          for any indirect, consequential or special liability
                          arising out of or in any way related to your use of
                          the Platform.
                        </p>
                        <p>
                          <strong>6. Indemnification</strong>
                        </p>
                        <p>
                          You hereby fully indemnify CCAR from and against any
                          and all liabilities, costs, demands, causes of action,
                          damages and expenses (including attorney’s fees)
                          arising out of or in any way related to your breach of
                          any of the provisions of these Terms
                        </p>
                        <p>
                          <strong>7. Severability</strong>
                        </p>
                        <p>
                          If any provision of these Terms is found to be
                          unenforceable or invalid under any applicable law,
                          such unenforceability or invalidity shall not render
                          these Terms unenforceable or invalid as a whole, and
                          such provisions shall be deleted without affecting the
                          remaining provisions herein.
                        </p>
                        <p>
                          <strong>8. Variation of Terms</strong>
                        </p>
                        <p>
                          CCAR is permitted to revise these Terms at any time as
                          it sees fit, and by using the Platform you are
                          expected to review such Terms on a regular basis to
                          ensure you understand all terms and conditions
                          governing use of the Platform.
                        </p>
                        <p>
                          <strong>9. Assignment</strong>
                        </p>
                        <p>
                          CCAR shall be permitted to assign, transfer, and
                          subcontract its rights and/or obligations under these
                          Terms without any notification or consent required.
                          However, you shall not be permitted to assign,
                          transfer, or subcontract any of your rights and/or
                          obligations under these Terms.
                        </p>
                        <p>
                          <strong>10. Entire Agreement</strong>
                        </p>
                        <p>
                          These Terms, including any legal notices and
                          disclaimers contained on the Platform, constitute the
                          entire agreement between CCAR and you in relation to
                          your use of the Platform, and supersede all prior
                          agreements and understandings with respect to the
                          same.
                        </p>
                        <p>
                          11. Governing Law and Jurisdiction/Waiver of Jury
                          Trial
                        </p>
                        <p>
                          These Terms of Use and any claim or dispute arising
                          out of, relating to or in connection with these Terms
                          of Use or the transactions contemplated hereby,
                          whether in contract, tort or otherwise, shall be
                          governed by and construed in accordance with the laws
                          of the State of Conecticut without giving effect to
                          its conflicts of law principles. Each party
                          irrevocably consents and agrees that any legal action,
                          suit or proceeding against either of them arising out
                          of, relating to or in connection with the transaction
                          contemplated hereby or disputes relating hereto may be
                          brought only in United States District Court for the
                          District of Connecticut, or if such court does not
                          have jurisdiction, in the courts of the State of
                          Connecticut and hereby irrevocably accepts and submits
                          to the exclusive jurisdiction of the aforesaid courts
                          in personam, with respect to any such action, suit or
                          proceeding. EACH PARTY WAIVES TO THE FULLEST EXTENT
                          PERMITTED BY LAW ANY RIGHT TO TRIAL BY JURY IN ANY
                          ACTION, SUIT OR PROCEEDING BROUGHT TO ENFORCE, DEFEND
                          OR INTERPRET ANY RIGHTS OR REMEDIES ARISING UNDER,
                          RELATING TO OR IN CONNECTION WITH THESE TERMS OF USE.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default TermsAndCondition;



// WEBPACK FOOTER //
// ./src/components/TermsAndCondition/TermsAndCondition.js